import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { addcardetails, addcarnum } from "../../../Redux/actions/NumCaration";
import { addVahanData } from "../../../Redux/actions/NumBikeation";
import { NavbarJourney } from "../../Navbar/NavbarJourney";
import {
  Form,
  Input,
  Row,
  Col,
  Button,
  Avatar,
  Card,
  DatePicker,
  Spin,
  Select,
} from "antd/lib";
import CarImg from "../../../images/car-insur-bf-quotes.jpg";
import CarFrontImg from "../../../images/car-front.jpg";
// import BikeImg from '../../images/bike-insur.jpg';
import moment from "moment";
// import axiosInCar from "../../Redux/axios/AxiosInstance";
import axiosInCar from "../../../Redux/axios/AxiosInCar";
// import LazyLoad from 'react-lazyload';

const { Meta } = Card;

export default function FWheelmake() {
  const carnum = useSelector((state) => state?.cardetail?.carnum);
  const vechicleData = useSelector((state) => state?.common?.vahanData);
  const CarMakeData = useSelector((state) => state?.cardetail?.carMakeData);

  const [form] = Form.useForm();
  const [formLayout] = useState("vertical");
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();
  const [carNumDetail, setBikeNumdeail] = useState(carnum);
  const [options, setOptions] = useState([]);
  const [MakeData, setMakeData] = useState([]);
  const [ModalData, setModalData] = useState([]);
  const [VarientData, setVarientData] = useState([]);
  const [Makeoptions, setMakeoptions] = useState([]);
  const [VarientOption, setVarientOptions] = useState([]);
  const [bikemake, setBikeMake] = useState(CarMakeData?.make);
  const [bikemodel, setModelSearch] = useState(CarMakeData?.model);
  const [SelectCarVarient, setSelectVarient] = useState("");
  const [saveloading, setIsaveloading] = useState(false);
  const [VehicleCode, setVehicleCode] = useState(CarMakeData?.VehicleCoreCode);

  //console.log("vechicleData",vechicleData)

  useEffect(() => {
    //console.log(carNumDetail)
    form.setFieldsValue({
      CarNumber: carNumDetail?.car_number,
      registrationYear: vechicleData?.registration_date
        ? moment(vechicleData?.registration_date)
        : null,
    });
  }, [vechicleData, CarMakeData]);

  useEffect(() => {
    axiosInCar
      .get(`vehicle_masters?no_of_wheels=4`)
      .then((res) => {
        // console.log('vehicle_masters?no_of_wheels=4',res);
        const resp = res?.data?.makes;
        //console.log(resp);
        const makeData = resp.map((item) => item);
        // console.log("resp", makeData);
        setMakeoptions(makeData);
        setMakeData(makeData);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  const handleSearchMake = (searchText) => {
    setIsaveloading(true);
    const filteredOptions = Makeoptions.filter((option) =>
      option.toLowerCase().includes(searchText.toLowerCase())
    );
    //console.log(filteredOptions)
    setMakeData(filteredOptions);
  };

  const onSelectMake = (data) => {
    // console.log("onSelect", data);
    setBikeMake(data);
    setIsaveloading(false);
    form.setFieldsValue({
      carModel: "",
      carVarient: "",
    });
  };
  //console.log(bikemake)

  useEffect(() => {
    axiosInCar
      .get(`vehicle_masters?no_of_wheels=4&make=${bikemake}`)
      .then((res) => {
        //console.log(res);
        const resp = res?.data?.models;
        //console.log(resp);
        const modelData = resp.map((item) => item);
        // console.log("resp", modelData);
        setOptions(modelData);
        setModalData(modelData);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [bikemake]);

  const handleSearch = (searchText) => {
    setIsaveloading(true);
    const filteredOptions = options.filter((option) =>
      option.toLowerCase().includes(searchText.toLowerCase())
    );
    setModalData(filteredOptions);
  };
  const ModelChange = (e) => {
    setModelSearch(e);
    setIsaveloading(false);
  };
  const onSelect = (data) => {
    console.log("onSelect", data);
    setModelSearch(data);
    setIsaveloading(false);
  };
  useEffect(() => {
    axiosInCar
      .get(`vehicle_masters?no_of_wheels=4&make=${bikemake}&model=${bikemodel}`)
      .then((res) => {
        //console.log(res);
        const resp = res?.data?.variants;
        // console.log(resp);
        // const varientData = resp.map((option, item) => console.log(option, item));
        // console.log("resp", varientData);
        setVarientOptions(resp);
        setVarientData(resp);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [bikemodel]);

  const VarientChange = (variant, option) => {
    // console.log(varient)
    setSelectVarient(variant);
    axiosInCar
      .get(
        `vehicle_masters?no_of_wheels=4&make=${bikemake}&model=${bikemodel}&variant=${variant}`
      )
      .then((res) => {
        const resp = res?.data;
        // console.log(resp);
        // setVehicleCode(resp?.vehicle_core_code)
        dispatch(
          addcardetails({
            ...CarMakeData,
            VehicleCoreCode: resp?.vehicle_core_code,
            customized_variant: option?.label,
          })
        );
      })
      .catch((err) => {
        console.log(err);
      });
    setIsaveloading(false);
  };

  const buttonItemLayout = {
    wrapperCol: {
      span: 24,
    },
  };

  const onDateChange = (date, dateString) => {
    //console.log(date);
    console.log(dateString);
    //setRegDate(dateString)
  };
  const handleInputChange = (e) => {
    setIsaveloading(true);
    e.target.value = e.target.value.toUpperCase();
    setBikeNumdeail({
      ...carNumDetail,
      car_number: e.target.value.toUpperCase(),
    });
    form.setFieldsValue({ CarNumber: e.target.value });
    setIsaveloading(false);
  };
  //console.log(carNumDetail)
  const onFinish = (values) => {
    //console.log(values)
    setLoading(true);
    values.registrationYear = moment(values.registrationYear).format(
      "YYYY-MM-DD"
    );
    //console.log(values);

    dispatch(
      addcardetails({
        ...CarMakeData,
        make: values.carMake,
        model: values.carModel,
        year: values.registrationYear,
        varbike: values.carVarient,
        // VehicleCoreCode: VehicleCode,
      })
    );
    dispatch(addcarnum(carNumDetail));
    const updatedVahanData = {
      ...vechicleData,
      registration_date: values.registrationYear,
    };
    dispatch(addVahanData(updatedVahanData));
    setTimeout(() => {
      setLoading(false);
      history.push("/policystep2");
    }, 1000);
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <>
      <NavbarJourney />
      <section
        className="bg-light py-4"
        style={{ minHeight: "calc(100vh - 50px)" }}
      >
        <div className="container">
          <div className="row align-items-start justify-content-between">
            <Form
              layout={formLayout}
              form={form}
              className="ant-quote-form col-xl-6 col-lg-6 col-md-6"
              requiredMark={false}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
            >
              <h6 className="ant-quote-form-head">Enter Vehicle Details</h6>

              <Row gutter={24}>
                <Col span={24}>
                  <Form.Item
                    label="Car Number"
                    name="CarNumber"
                    rules={[
                      {
                        pattern: /^[A-Z]{2}[0-9]{1,2}[A-Z]{1,2}[0-9]{3,4}$/i,
                        message: "Invalid Vehicle No",
                      },
                      { required: true, message: "Enter Vehicle No" },
                    ]}
                  >
                    <Input
                      onChange={handleInputChange}
                      placeholder="Enter Car Number (eg. DL1SAB1234)"
                    />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    name="carMake"
                    label="Select Make"
                    rules={[
                      {
                        required: true,
                        message: "Please Select Make",
                      },
                    ]}
                    initialValue={CarMakeData?.make}
                  >
                    <Select
                      placeholder="Select Make"
                      showSearch
                      filterOption={(input, option) =>
                        option.label
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      options={MakeData?.map((p, index) => ({
                        key: index,
                        value: p,
                        label: p,
                      }))}
                      //onChange={(e)=>onSelectMake(e)}
                      onSelect={(e) => onSelectMake(e)}
                    />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    name="carModel"
                    label="Select Model"
                    rules={[
                      {
                        required: true,
                        message: "Please Select Model",
                      },
                    ]}
                    initialValue={CarMakeData?.model}
                  >
                    <Select
                      placeholder="Select Model"
                      showSearch
                      filterOption={(input, option) =>
                        option.label
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      options={ModalData?.map((p, index) => ({
                        key: index,
                        value: p,
                        label: p,
                      }))}
                      //onChange={(e)=>ModelChange(e)}
                      onSelect={(e) => ModelChange(e)}
                    />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    name="carVarient"
                    label="Select Variant"
                    rules={[
                      {
                        required: true,
                        message: "Please Select Variant",
                      },
                    ]}
                    initialValue={CarMakeData?.varbike}
                  >
                    <Select
                      placeholder="Select Variant"
                      showSearch
                      filterOption={(input, option) =>
                        option.label
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      options={VarientData?.map((p, index) => ({
                        key: index,
                        value: p.variant,
                        label: p.customized_variant,
                      }))}
                      onChange={(variant, option) =>
                        VarientChange(variant, option)
                      }
                    />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    label="Registration Year"
                    name="registrationYear"
                    rules={[
                      {
                        required: true,
                        message: "please input Registration Year",
                      },
                    ]}
                    //initialValue={vechicleData?.registration_date ? moment(vechicleData?.registration_date) : null}
                  >
                    <DatePicker
                      style={{ width: "100%", padding: "8px" }}
                      format="YYYY-MM-DD"
                      onChange={onDateChange}
                      placeholder="Select Registration Date"
                    />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item {...buttonItemLayout}>
                    <Button
                      style={{ width: "100%" }}
                      loading={loading}
                      type="primary"
                      htmlType="submit"
                    >
                      GET QUOTES
                    </Button>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
            {/* { !isEdit ? (  */}
            <div className="col-xl-5 col-lg-6 col-md-6 bike-info-quotebef">
              <h1 className="bike-quotebef-txt">Your Vechicle Details</h1>
              <Card
              // actions={[
              //   !isEdit ? (
              //     <Button type="primary" className="action-edit" onClick={handleEdit}>
              //     <EditOutlined key="save" />
              //     Edit
              //   </Button>
              //   ) : (
              //     <Button type="primary" className="action-edit" onClick={handleSave} loading={saveloading}>
              //       <SaveOutlined key="save" />
              //       Save
              //     </Button>
              //   )
              // ]}
              >
                <Spin spinning={saveloading}>
                  <Meta
                    avatar={<Avatar src={CarFrontImg} />}
                    title={
                      <div className="meta-title-ant">
                        <p className="mb-0">
                          {CarMakeData?.make ? CarMakeData.make : bikemake}
                        </p>
                        <p className="mb-0">{carNumDetail?.car_number}</p>
                      </div>
                    }
                    description={
                      <div className="meta-description-ant">
                        <p className="mb-0">
                          {CarMakeData?.model ? CarMakeData.model : bikemodel}
                        </p>
                        <p className="mb-0 text-end">
                          {CarMakeData?.varbike
                            ? CarMakeData.varbike
                            : SelectCarVarient}
                        </p>
                      </div>
                    }
                  />
                </Spin>
              </Card>
              <div className="vehdetail-img">
                {/* <LazyLoad height={200} offset={100}> */}
                <img
                  src={CarImg}
                  loading="eager"
                  style={{ width: "85%", borderRadius: "10px" }}
                ></img>
                {/* </LazyLoad> */}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
